<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div class="fakeoverlay" :class="{ disabled: !selectStatus }" @click="setActive" />
        <el-select
          v-model="selectValue"
          class="control__select"
          :disabled="!selectStatus"
          placeholder="false"
          @change="changeOption"
        >
          <el-option
            v-for="(option, index) in smv"
            :key="index"
            :label="index + 1"
            :value="index + 1"
          />
        </el-select>
        <radio-input-custom
          v-show="selectStatus"
          v-if="innerComponent"
          :title="innerComponent.title"
          :default="innerComponent.default"
          :hint="innerComponent.hint"
          :options="innerComponent.options"
          :status="selectStatus"
          :select-value="selectValue"
        />
      </div>
      <el-checkbox
        v-model="selectStatus"
        :disabled="smv[0].type === 'view'"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import RadioInputCustom from "@/widgets/options/RadioInputCustom";
export default {
  name: "SelectInputCustom",
  components: { RadioInputCustom },
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: Function,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
    innerComponent: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectValue: this.default,
      selectStatus: this.status,
      showHint: false,
    };
  },
  computed: {
    ...mapState(["clearOptions", "settings"]),
    smv() {
      return this.settings.smv;
    },
  },
  watch: {
    clearOptions(val) {
      if (val) {
        this.selectStatus = false;
      }
    },
    eventClick(val) {
      this.selectStatus = val;
      this.value = this.default;
    },
    selectStatus(val) {
      this.changeOption();
    },
  },
  methods: {
    ...mapMutations(["CHANGE_SVM"]),

    setActive() {
      if (this.settings.smv[0].type === "view") {
        return false;
      }

      return (this.selectStatus = !this.selectStatus);
    },

    changeOption() {
      const value = [...this.smv].map((i) => {
        if (i.pined) delete i.pined;
        return i;
      });

      if (this.selectStatus && value.length && !value[this.selectValue - 1].pined) {
        value[this.selectValue - 1].pined = "start";
      }
      this.CHANGE_SVM(value);
    },
  },
};
</script>
